import React, { useState } from "react";
import {connect} from "react-redux";
import {JobTypeDescription} from "./";
import {Pagination, SearchBox} from "../../../../components"
import {JobQueueDialog} from "./JobQueueDialog";
import * as at from "../actionTypes";
import _ from "lodash";
import {HistoryItem} from "./HistoryItem";

export const UnconnectedManageToolJobsList = ({
  isQueryValid,
  isQueryExecuted,
  isLoading,
  items,
  page,
  pageSize,
  dispatch
}) => {
  const [textQuery, setTextQuery] = useState("")
  const matchedItems = textQuery && textQuery.trim() ? items.filter(x => {
    let joined = [x.title, x.description, x.id].join(' ');
    return joined.toLowerCase().includes(textQuery)
  }) : items;
  const pageItems = matchedItems.slice(page * pageSize, (page + 1) * pageSize);
  return (
    <div>
      <JobTypeDescription />
      <div>
        {!isQueryValid || !isQueryExecuted ? (
          <div className="alert alert-warning">Set a Search on the Left</div>
        ) : isLoading ? (
          <div className="text-center">
            <i className="fas fa-spinner fa-spin fa-3x" />
          </div>
        ) : !items.length ? (
          <div className="alert alert-warning">No Results Found</div>
        ) : (
          <div>
            <JobQueueDialog />
            <div className="clearfix" style={{ marginBottom: "10px" }}>
              <div className="pull-right">
                <a
                  className="btn-link"
                  tabIndex={0}
                  onClick={() =>
                    dispatch({
                      type: at.SET_ALL_ITEMS_SELECTION,
                      selected: false
                    })
                  }
                >
                  Deselect All
                </a>
                &nbsp; | &nbsp;
                <a
                  className="btn-link"
                  tabIndex={0}
                  onClick={() =>
                    dispatch({
                      type: at.SET_ALL_ITEMS_SELECTION,
                      selected: true
                    })
                  }
                >
                  Select All
                </a>
                &nbsp; | &nbsp;
                <a
                  className="btn-link"
                  tabIndex={0}
                  onClick={() =>
                    dispatch({ type: at.SET_ITEMS_SELECTED, items: pageItems })
                  }
                >
                  Select Visible
                </a>
                &nbsp; | &nbsp;
                <SearchBox
                  style={{ display: "inline-block" }}
                  tooltip="Search Labels"
                  placeholder="Search ..."
                  updateSearchTerm={text => {
                    dispatch({
                      type: at.SET_ENTRIES_PAGE,
                      page: 0
                    });
                    setTextQuery((text && text.trim().toLowerCase()) || "");
                  }}
                  value={textQuery}
                />
              </div>
            </div>
            <div className="container-fluid">
              {_.chunk(pageItems, 2).map(rowItems => {
                return (
                  <div key={rowItems.map(x => x.id).join("")} className="row">
                    {rowItems.map(item => {
                      return (
                        <div
                          key={item.id}
                          style={{ marginBottom: "5px" }}
                          className="col-md-6"
                        >
                          <HistoryItem item={item} />
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </div>
            <div className="d-flex justify-content-center text-center my-2">
              <Pagination
                totalPages={matchedItems.length === 0 ? 1 : Math.ceil(matchedItems.length / pageSize)}
                currentPage={page + 1}
                onChange={pageNumber => {
                  dispatch({
                    type: at.SET_ENTRIES_PAGE,
                    page: pageNumber - 1
                  });
                }}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}



export const ManageToolJobsList = connect(function mapStateToProps(state, ownProps) {
  const {
    isQueryValid,
    entriesLoading,
    isQueryExecuted,
    entries,
    page, pageSize
  } = state.manageTool;
  return {
    isQueryValid,
    isQueryExecuted,
    page, pageSize,
    isLoading: entriesLoading,
    items: entries,
    ...ownProps,
  }
})(UnconnectedManageToolJobsList)
